import React, { useState, useEffect } from 'react'

import './styles.scss'

const chunkArray: (a: tableData[], b: number) => tableData[][] = (
  myArray,
  chunk_size
) => {
  const size = Math.ceil(chunk_size)
  let index = 0
  const arrayLength = myArray.length
  const tempArray = []
  for (index = 0; index < arrayLength; index += size) {
    const myChunk = myArray.slice(index, index + size)
    tempArray.push(myChunk)
  }
  return tempArray
}

export const SwissCasesTable = ({ data }: { data: tableData[] }) => {
  const [drawData, setDrawData] = useState<tableData[][] | undefined>(undefined)
  const [maxCount, setmaxCount] = useState<number>(0)

  useEffect(() => {
    const sumed = data.map(m => +m.cases + +m.death)
    setmaxCount(Math.max(...sumed))
    data.sort((a: tableData, b: tableData) => +b.cases - +a.cases)
    setDrawData(chunkArray(data, data.length / 3))
  }, [data])

  return (
    <div className='swissCasesTable'>
      {drawData &&
        drawData.map((d, i) => {
          return (
            <table key={i}>
              <tbody>
                {d.map((e, j) => {
                  return (
                    <React.Fragment key={j}>
                      <tr>
                        <td className={'name' + (i === 0 ? ' first' : '')}>
                          {e.abr}
                        </td>
                        <td className='cases'>{e.cases || 0}</td>
                        <td className='death'>{e.death || 0}</td>
                        {i < data.length - 1 && <td className='spacer' />}
                      </tr>
                      <tr>
                        <td colSpan={4} className='bars'>
                          <div className='barWrapper'>
                            <div
                              className='casesBar'
                              style={{
                                width: (+e.cases * 100) / maxCount + '%'
                              }}
                            />
                            <div
                              className='deathBar'
                              style={{
                                width: (+e.death * 100) / maxCount + '%'
                              }}
                            />
                          </div>
                        </td>
                      </tr>
                    </React.Fragment>
                  )
                })}
              </tbody>
            </table>
          )
        })}
    </div>
  )
}
